import gemini from '../../public/images/logo-gemini.svg?url';
import opeanai from '../../public/images/logo-gpt.svg?url';
import anthropic from '../../public/images/logo-claude.svg?url';
import { UserAvatarLive } from '../common/UserAvatarLive';

const makeAbsolute = (path) => {
  return path.startsWith('/') ? path : '/' + path;
};

const images = {
  'gemini': makeAbsolute(gemini),
  'anthropic': makeAbsolute(anthropic),
  'openai': makeAbsolute(opeanai),
}

export default function AIModelBadge({model, showName = false}) {
  if(!model) {
    return null;
  }

  if(model.match(/^(\d\.\d+$)/) || model.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
    return <span className={'badge badge-light'}><span className={'h5 align-middle'}>🥩</span><UserAvatarLive id={model} className={'zoom-75'}/></span>
  }
  
  let extraEmoji = null;
  let modelGroup = '';
  if(model.match(/^(gpt-|o4|o3)/)) {
    modelGroup = 'openai';
    if(model.match(/mini/)) {
      extraEmoji = '⚡';
    } else if(model.match(/o3|o4/)) {
      extraEmoji = '💵🧠';
    }
  } else if(model.match(/^claude-/)) {
    modelGroup = 'anthropic';
  } else if(model.match(/^gemini-/)) {
    modelGroup = 'gemini';
    if(model.match(/flash-lite/)) {
      extraEmoji = '⚡⚡' + (model.match(/2\.5/)? '2.5' : '');
    } else if(model.match(/flash/)) {
      extraEmoji = '⚡' + (model.match(/2\.5/)? '2.5' : '');
    } else {
      extraEmoji = '🧠';
    }
  }

  return <span className={'badge badge-light position-relative'}>
    <img alt={model} style={{height: '18px', width: '18px', objectFit: 'contain'}} title={model} className={''} src={images[modelGroup]}/>
    {showName ? ' '+model : null}
    {extraEmoji ? <span className={'position-absolute small pos-bottom  pos-left translucent'}>{extraEmoji}</span> : null }
  </span>;
}
